module.exports = __webpack_public_path__ + "static/img/solutionDetailPic2.25e382d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic2.png
// module id = Y6vl
// module chunks = 1